// extracted by mini-css-extract-plugin
export var cardIcon = "_5o-4";
export var checkboxCard = "_5o-0";
export var checkboxCardSelected = "_5o-3";
export var disabled = "_5o-1";
export var outerBorder = "_5o-2";
export var spacerMedium = "_5o-7";
export var spacerSmall = "_5o-6";
export var spacerXsmall = "_5o-5";